import { render } from "./SaleItem.vue?vue&type=template&id=2383ebb0"
import script from "./SaleItem.vue?vue&type=script&lang=js"
export * from "./SaleItem.vue?vue&type=script&lang=js"
script.render = render

export default script